import api from './api';
import api2 from './api2';

export function saveClientData(data) {
    return api.put(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/infodni`, data)
}

export function getClientList(idAsesor) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/infodni/assesor/${idAsesor}`);
}

export function getClientDataFull(tipoIdentificacion, identificacion) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clientes/${tipoIdentificacion}/${identificacion}`)
}

export function getImagenesCedula(idcredito) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/imagenescedula/${idcredito}`)
}

export function getDataCliente(cedula) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/cliente/${cedula}/getDataClienteXml`)
}

export function getCoreImagenesCedula(identificacion) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/habeasdata/obtenerImagenesIdentidad/${identificacion}`)
}